import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import funcoesGerais from '../../funcoes/funcoesGerais';
import { ConsultaBoleto, ConsultaBoletoDemanda } from '../../interfaces/consultaBoleto';
import { PedidoConsultaElement } from '../../interfaces/pedido.consulta';
import { SicoobService } from '../../services/sicoob';
import { UsuarioService } from '../../services/usuario.service';
import { environment } from '../../../environments/environment';

import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { MatDialog } from '@angular/material/dialog';
import { AlertaExportarDialog } from '../dialogs/exportar-dialog/exportar-dialog';
import { ConsultaBoletoRelatorio } from '../../interfaces/consultaBoletoRelatorio';
import { TokenSicoob } from '../../interfaces/sicoob/token';

const MAXIMO_BOLETOS_SINCRONIZACAO: number = 10;

@Component({
  selector: 'app-relatorio-boletos',
  templateUrl: './relatorio-boletos.component.html',
  styleUrls: ['./relatorio-boletos.component.scss', '../../styles/estilo.padrao.scss']
})
export class RelatorioBoletosComponent implements OnInit {
  uid;
  tipoCadastro = 'Vendedor';
  bConsulta: boolean = false;
  range: FormGroup;
  tokenSicoob: TokenSicoob;

  minDate: Date = new Date();

  sTipoBusca: string | boolean = 'Data de emissão';
  aTipoBusca: any[] = [
    { value: 'Data de emissão', name: 'Data de emissão' },
    { value: 'Data de vencimento', name: 'Data de vencimento' },
    { value: 'Boletos vencidos', name: 'Boletos vencidos' },
  ];

  sBuscaStatusBoleto: string | boolean = 'Todos';
  aStatusBoleto: any[] = [
    { value: 'Todos', name: 'Todos' },
    { value: 'Em Aberto', name: 'Em Aberto' },
    { value: 'Pago', name: 'Pago' },
    { value: 'Cancelado', name: 'Cancelado' },
  ];

  $boletos: any;
  displayedColumns: string[] = ['Pedido', 'Cliente', 'TelefoneCliente', 'DataEmissao', 'DataVencimento', 'Valor', 'SituacaoBoleto', 'Download', 'Consultar'];
  boletosSource;
  boletosData: ConsultaBoletoRelatorio[] = new Array();
  boletosPendentes: ConsultaBoleto[] = new Array();
  consultaBoletoDemanda: ConsultaBoletoDemanda[] = new Array();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private sicoobService: SicoobService,
    private af: AngularFireAuth,
    private usuarioService: UsuarioService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private dialog: MatDialog,
  ) {
    this.range = new FormGroup({
      start: new FormControl(),
      end: new FormControl()
    });

    this.uid = localStorage.getItem('uid');

    this.af.authState.subscribe((snap: any) => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.tipoCadastro = 'Vendedor';
      } else
        this.tipoCadastro = 'Admin';
    });

    const currentYear = new Date().getFullYear() - 3;
    this.minDate = new Date(currentYear, 0, 1);

    this.range.get('start')?.patchValue(new Date());
    this.range.get('end')?.patchValue(new Date());

    this.activeRoute.queryParams.subscribe(params => {
      let filtrarBoletosVencidos = params['filtrarBoletosVencidos'];
      if (filtrarBoletosVencidos) {
        this.filtrarBoletosVencidos();
        this.sTipoBusca = 'Boletos vencidos';
      }
    });
  }

  ngOnInit(): void {
  }

  buscarBoletos() {
    this.spinner.show('relatorio-boletos');
    let timestampInicio: Date = new Date(this.range?.get('start')?.value);
    timestampInicio.setHours(0);
    timestampInicio.setMinutes(0);
    timestampInicio.setSeconds(0);
    timestampInicio.setMilliseconds(0);

    let timestampFinal: Date = new Date(this.range?.get('end')?.value);
    timestampFinal.setHours(23);
    timestampFinal.setMinutes(59);
    timestampFinal.setSeconds(59);
    timestampFinal.setMilliseconds(999);
    var difference = (timestampInicio.getFullYear() * 12 + timestampInicio.getMonth()) - (timestampFinal.getFullYear() * 12 + timestampFinal.getMonth());

    if (difference >= -12) {
      this.usuarioService.setLog("Consulta relatório de boletos: " + timestampInicio.getTime() + " fim: " + timestampFinal.getTime(), null, this.uid);

      this.$boletos = this.usuarioService.getBoletosTimestamp(timestampInicio.getTime(), timestampFinal.getTime(), this.sTipoBusca).pipe(take(1)).subscribe((snap: any) => {
        let auxBoletos: ConsultaBoletoRelatorio[] = new Array();
        let dados: ConsultaBoletoRelatorio;
        if (snap.length > 0) {

          snap.forEach((item, index) => {
            dados = item.payload.val() as ConsultaBoletoRelatorio;
            dados.ID = item.key;
            dados.DataEmissao = funcoesGerais.tratarData(dados.TimestampEmissao);
            dados.DataVencimento = funcoesGerais.tratarData(dados.TimestampVencimento);
            dados.ValorString = `R$ ${dados.Valor.toFixed(2).replace('.', ',')}`;
            if (this.validarFiltro(dados.SituacaoBoleto)) {
              auxBoletos.push(dados as ConsultaBoletoRelatorio);
            }
          });
        }
        this.finalizarRelatorioDadosPedidos(auxBoletos);
      });

    } else {
      this.toastr.warning('Não é possível realizar um filtro acima de 12 meses!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
      setTimeout(() => this.spinner.hide('relatorio-boletos'), 300);
    }
  }

  filtrarBoletosVencidos() {
    this.spinner.show('relatorio-boletos');

    this.usuarioService.getAllBoletosPendentes().pipe(take(1)).subscribe((snap: any) => {
      let auxBoletos: ConsultaBoletoRelatorio[] = new Array();
      if (snap) {
        const dataAtual: Date = new Date();
        let auxDateVencimento: Date = new Date();
        let dados: ConsultaBoletoRelatorio;

        snap.forEach((item, index) => {
          dados = item.payload.val() as ConsultaBoletoRelatorio;
          auxDateVencimento.setTime(dados.TimestampVencimento);

          if (auxDateVencimento < dataAtual) {
            dados.ID = item.key;
            dados.DataEmissao = funcoesGerais.tratarData(dados.TimestampEmissao);
            dados.DataVencimento = funcoesGerais.tratarData(dados.TimestampVencimento);
            dados.ValorString = `R$ ${dados.Valor.toFixed(2).replace('.', ',')}`;
            auxBoletos.push(dados as ConsultaBoletoRelatorio);
          }
        });
      }

      this.finalizarRelatorioDadosPedidos(auxBoletos);
    });
  }

  async retornarPedidoBoleto(idPedido: number): Promise<PedidoConsultaElement | null> {
    let dados: PedidoConsultaElement;
    return new Promise(resolve => {
      this.usuarioService.getPedidoPorNumero(idPedido).pipe(take(1)).subscribe(snap => {
        if (snap.payload.exists()) {
          dados = snap.payload.val() as PedidoConsultaElement;
        }
        resolve(dados);
      });
    });
  }

  finalizarRelatorioDadosPedidos(boletos: ConsultaBoletoRelatorio[]) {
    let auxBoletosCompleto: ConsultaBoletoRelatorio[] = new Array();
    let auxBoletos: ConsultaBoletoRelatorio[] = new Array();
    Promise.all(boletos.map(async (boleto: ConsultaBoletoRelatorio) => {
      console.log(this.uid)
      console.log(boleto.IDVendedor)
      console.log(boleto)
      if (this.tipoCadastro === 'Admin' || boleto.IDVendedor === this.uid) {
        const dadosPedido: any = await this.retornarPedidoBoleto(boleto.Pedido);
        boleto.Cliente = dadosPedido.Nome;
        boleto.TelefoneCliente = dadosPedido.Telefone;
        boleto.TelefoneCliente = dadosPedido.Telefone;
        boleto.IDBoletoPedido = dadosPedido.IDBoleto;
        boleto.IDBoletoPedido2 = dadosPedido.IDBoleto2;
        boleto.IDVendedor = dadosPedido.IDVendedor;
        auxBoletosCompleto.push(boleto);
      }

    })).then((resp => {

      if (this.sTipoBusca === 'Data de emissao')
        auxBoletos = auxBoletosCompleto.sort((a, b) => a.TimestampEmissao - b.TimestampEmissao);
      else
        auxBoletos = auxBoletosCompleto.sort((a, b) => a.TimestampVencimento - b.TimestampVencimento);

      this.boletosSource = new MatTableDataSource(auxBoletos);
      setTimeout(() => {
        this.boletosSource.paginator = this.paginator;
      }, 10);
      this.bConsulta = true;

      setTimeout(() => {
        this.spinner.hide('relatorio-boletos');
      }, 100);

      this.boletosData = auxBoletos;
    })).catch(error => this.alertarErro())
  }

  sincronizarBoletos() {
    this.spinner.show('default');

    this.usuarioService.getAllBoletosPendentes().pipe(take(1)).subscribe(async snap => {
      if (snap.length > 0) {
        let dados: ConsultaBoleto;
        let auxBoletosPendentes: ConsultaBoleto[] = new Array();

        snap.forEach((item: any, index) => {
          dados = item.payload.val() as ConsultaBoleto;
          dados.ID = item.key;

          auxBoletosPendentes.push(dados);
        });

        // this.consultarSicoobBoletoRecursivo(auxBoletosPendentes.slice(0, 50), 0);
        this.tokenSicoob = {
          access_token: '',
          statusCode: 0,
          dataSolicitacao: null
        };

        // auxBoletosPendentes = auxBoletosPendentes.filter(b => b.Pedido === 33326)
        console.log('auxBoletosPendentes', auxBoletosPendentes)
        this.consultarSicoobBoletoRecursivo(auxBoletosPendentes, 0);

        // this.toastr.warning(`Sincronizando ${auxBoletosPendentes.length} boletos. Aguarde!`, 'Status', { progressBar: true, positionClass: 'toast-top-center', timeOut: auxBoletosPendentes.length * 600 });

        this.usuarioService.setLog("Sincronização de boletos sicoob." + this.usuarioService.tratarData(new Date().getTime()), null, this.uid);
      } else {
        this.toastr.success('Não há boletos para serem analisados!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
        this.spinner.hide('default');
      }
    });
  }

  async consultarSicoobBoletoRecursivo(boletosPendentes: ConsultaBoleto[], ultimoIndexFinal: number) {
    try {
      this.tokenSicoob = await this.sicoobService.retornaTokenValidado(this.tokenSicoob);

      console.log('Loop')
      console.log('ultimoIndexFinal: ' + ultimoIndexFinal);

      this.toastr.clear();
      this.toastr.warning(`Sincronizando ${ultimoIndexFinal !== 0 ? (ultimoIndexFinal + MAXIMO_BOLETOS_SINCRONIZACAO < boletosPendentes.length ? ultimoIndexFinal + MAXIMO_BOLETOS_SINCRONIZACAO : boletosPendentes.length) : MAXIMO_BOLETOS_SINCRONIZACAO}/${boletosPendentes.length} boletos. Aguarde!`, 'Status', { progressBar: true, positionClass: 'toast-top-center', timeOut: 120000 });
      if (this.tokenSicoob.statusCode === 200) {
        if (boletosPendentes.length > MAXIMO_BOLETOS_SINCRONIZACAO) {
          if (ultimoIndexFinal === 0) {
            await this.sincronizarSicoobBoletos(boletosPendentes.slice(0, MAXIMO_BOLETOS_SINCRONIZACAO));
            this.consultarSicoobBoletoRecursivo(boletosPendentes, MAXIMO_BOLETOS_SINCRONIZACAO);
          } else {
            if (boletosPendentes.length - ultimoIndexFinal > MAXIMO_BOLETOS_SINCRONIZACAO) {
              await this.sincronizarSicoobBoletos(boletosPendentes.slice(ultimoIndexFinal, ultimoIndexFinal + MAXIMO_BOLETOS_SINCRONIZACAO));
              this.consultarSicoobBoletoRecursivo(boletosPendentes, ultimoIndexFinal + MAXIMO_BOLETOS_SINCRONIZACAO);
            } else {
              await this.sincronizarSicoobBoletos(boletosPendentes.slice(ultimoIndexFinal, boletosPendentes.length));
              this.sincronizarBoletosPedidos(boletosPendentes);
            }
          }
        } else {
          await this.sincronizarSicoobBoletos(boletosPendentes);
          this.sincronizarBoletosPedidos(boletosPendentes);
        }
      } else {
        this.toastr.clear();
        this.toastr.error('Erro no fornecimento do token do sicoob!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
        this.recarregarPagina();
      }

    } catch (error) {
      this.toastr.error(`Erro ao seguir com sincronização. ${error}`, 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      this.recarregarPagina();
    }
  }

  async sincronizarSicoobBoletos(boletosPendentes: ConsultaBoleto[]) {
    console.log('sincronizarSicoobBoletos')
    let auxBoletos: ConsultaBoletoDemanda[] = [];
    for (let i = 0; i < boletosPendentes.length; i++) {
      auxBoletos.push({
        id: boletosPendentes[i].ID,
        nossoNumero: boletosPendentes[i].NossoNumero,
        numeroContrato: boletosPendentes[i].NumeroContrato
      });
    }
    console.log(JSON.stringify(auxBoletos));
    return new Promise((resolve) => {
      this.sicoobService.getStatusBoletoDemandaSicoob(boletosPendentes, this.tokenSicoob.access_token).subscribe((resp: { data: ConsultaBoletoDemanda[] }) => {
        console.log(resp);
        this.consultaBoletoDemanda = this.consultaBoletoDemanda.concat(resp.data);
        console.log('retornou consulta')
        resolve(true);
      });
    })
  }

  async sincronizarBoletosPedidos(boletosPendentes: ConsultaBoleto[]) {
    console.log('sincronizarBoletosPedidos')
    console.log(boletosPendentes)
    let boletosPedidoDuasParcelas: ConsultaBoleto[] = [];
    let cont = 1;

    let auxIndex: number;

    console.log('this.consultaBoletoDemanda', this.consultaBoletoDemanda)
    for (const auxConsultaBoletoDemanda of this.consultaBoletoDemanda) {
      auxIndex = boletosPendentes.findIndex(boleto => boleto.NossoNumero === auxConsultaBoletoDemanda.nossoNumero);
      if (auxIndex !== -1) {
        boletosPendentes[auxIndex].SituacaoBoleto = auxConsultaBoletoDemanda.situacaoBoleto;
      }
    }

    this.toastr.clear();

    for (const boleto of boletosPendentes) {
      console.log(boleto.Pedido);
      console.log(boleto.ID);
      console.log(boleto.SituacaoBoleto);
      await new Promise(async resolve => {
        this.toastr.info(`${cont}/${boletosPendentes.length} - Pedido: ${boleto.Pedido} - ${boleto.SituacaoBoleto}`, 'Status', { positionClass: 'toast-top-center', timeOut: 1000 });
        cont++;

        let mapPedido: { SituacaoBoleto: string; StatusPagamento: string; StatusBoleto: string; SituacaoSicoob: "Baixado" | "Liquidado"; };
        let mapBoleto: { SituacaoBoleto: string; Status: string; SituacaoSicoob: "Baixado" | "Liquidado"; };

        const pedido: PedidoConsultaElement = await this.getPedido(boleto.Pedido);
        if (pedido) {
          switch (boleto.SituacaoBoleto) {
            case 'Liquidado':
              mapPedido = {
                SituacaoBoleto: 'Pago',
                StatusPagamento: 'Pago',
                StatusBoleto: 'Pago',
                SituacaoSicoob: boleto.SituacaoBoleto
              };
              mapBoleto = {
                SituacaoBoleto: 'Pago',
                Status: 'Pago',
                SituacaoSicoob: boleto.SituacaoBoleto
              };
              console.log('updateStatusBoleto', mapBoleto)
              await this.usuarioService.updateStatusBoleto(boleto.ID, mapBoleto);

              if (pedido.NumeroParcelas === 1) {
                console.log(boleto.Pedido, mapPedido)
                await this.usuarioService.updateBoletoPedido(boleto.Pedido, mapPedido);
              } else {
                //Verifica se a outra parcela está paga
                const statusSegundoBoleto = await this.getSituacaoBoleto(boleto.ID === pedido?.IDBoleto ? pedido?.IDBoleto2 : pedido?.IDBoleto);

                //Ambas as parcelas estão pagas, atualizando pedido e parcela faltante;
                if (statusSegundoBoleto === 'Pago') {
                  await this.usuarioService.updateBoletoPedido(boleto.Pedido, mapPedido);
                }
              }
              break;

            case 'Baixado':
              mapPedido = {
                SituacaoBoleto: 'Cancelado',
                StatusPagamento: 'Cancelado',
                StatusBoleto: 'Cancelado',
                SituacaoSicoob: boleto.SituacaoBoleto
              };
              mapBoleto = {
                SituacaoBoleto: 'Cancelado',
                Status: 'Cancelado',
                SituacaoSicoob: boleto.SituacaoBoleto
              };

              console.log('updateStatusBoleto', mapBoleto)
              await this.usuarioService.updateStatusBoleto(boleto.ID, mapBoleto);

              if (pedido.NumeroParcelas === 1) {
                console.log(boleto.Pedido, mapPedido)
                await this.usuarioService.updateBoletoPedido(boleto.Pedido, mapPedido);
              } else {
                //Verifica se a outra parcela está paga
                const statusSegundoBoleto = await this.getSituacaoBoleto(boleto.ID === pedido?.IDBoleto ? pedido?.IDBoleto2 : pedido?.IDBoleto);

                //Ambas as parcelas estão pagas, atualizando pedido e parcela faltante;
                if (statusSegundoBoleto === 'Cancelado') {
                  await this.usuarioService.updateBoletoPedido(boleto.Pedido, mapPedido);
                }
              }
              break;
          }
        }

        resolve(true);
      });
    }
    this.finalizarSincronizacao();
  }

  finalizarSincronizacao() {
    console.log('finalizarSincronizacao');
    this.toastr.clear();
    this.toastr.success('Boletos sincronizados com sucesso!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
    this.recarregarPagina();
  }

  async getPedido(pedidoId: number): Promise<PedidoConsultaElement | null> {
    return await new Promise(resolve => {
      this.usuarioService.getPedidoPorNumero(pedidoId).pipe(take(1)).subscribe(async snap => {
        if (snap) {
          resolve(snap.payload.val() as PedidoConsultaElement);
        }
        resolve(null);
      });
    })
  }

  async getSituacaoBoleto(boletoId: string): Promise<string> {
    return await new Promise(resolve => {
      this.usuarioService.getBoleto(boletoId).pipe(take(1)).subscribe(snap => {
        if (snap) {
          const dados: ConsultaBoleto = snap as ConsultaBoleto;
          resolve(dados.Status);
        }

        resolve('');
      });
    })
  }

  visualizarPedido(boleto: ConsultaBoletoRelatorio) {
    if (this.tipoCadastro === 'Admin') {
      if (boleto.IDBoletoPedido === boleto.ID || boleto.IDBoletoPedido2 === boleto.ID) {
        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: boleto.Pedido } }));
      } else {
        this.toastr.clear();
        this.toastr.error('Este boleto não está vinculado ao pedido. A informação contida é apenas para controle de sistema.', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
      }
    } else {
      this.toastr.error('O vendedor não pode visualizar o pedido por este painel', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
    }
  }

  downloadBoleto(boleto: ConsultaBoletoRelatorio) {
    if (boleto.Status !== 'Cancelado' && boleto.Status !== 'Pago') {
      if (boleto.IDBoletoPedido === boleto.ID || boleto.IDBoletoPedido2 === boleto.ID) {
        this.sicoobService.imprimirBoletos(new Array(boleto.PDFbase64), `Boleto pedido ${boleto.Pedido} - Vencimento: ${funcoesGerais.tratarData(boleto.TimestampVencimento)}`);
      } else {
        this.toastr.clear();
        this.toastr.error('Este boleto não está vinculado ao pedido. A informação contida é apenas para controle de sistema.', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
      }
    } else
      this.toastr.error(`Este boleto está ${boleto.Status.toLowerCase()} e não pode ser baixado.`, 'Status', { progressBar: true, positionClass: 'toast-top-center', });

  }

  recarregarPagina() {
    setTimeout(() => {
      const mapFiltrarBoletosVencidos: any = this.sTipoBusca === 'Boletos vencidos' ? { queryParams: { filtrarBoletosVencidos: true } } : '';
      this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
        this.router.navigate(["/pages/relatorio-boletos"], mapFiltrarBoletosVencidos));
      this.spinner.hide('default');
    }, 1500);
  }

  alertarErro() {
    this.toastr.error("Não foi possível localizar boletos!", 'Erro');
    setTimeout(() => this.spinner.hide('relatorio-boletos'), 300);
  }

  validarFiltro(situacaoBoleto) {
    switch (this.sBuscaStatusBoleto) {
      case 'Todos':
        return true;

      case 'Em Aberto':
        return situacaoBoleto === 'Em Aberto';

      case 'Pago':
        return situacaoBoleto === 'Pago';

      case 'Cancelado':
        return situacaoBoleto === 'Cancelado';

      default: return false;
    }
  }

  exportar() {
    const dialogRef = this.dialog.open(AlertaExportarDialog, {
      data: { bPDF: true, bExcel: false, bCSV: false },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toastr.show('relatorio-boletos');




        this.imprimir(result.tipo);
      }
    });
  }

  imprimir(tipo) {
    var date = new Date();
    date.setTime(this.range.get('start')?.value);
    var dateFinal = new Date();
    dateFinal.setTime(this.range.get('end')?.value);

    switch (tipo) {
      //PDF
      case 0:
        let doc = new jsPDF('l', 'mm', [297, 210]);
        let corpo: any = [];
        this.boletosData.forEach(dado => {
          var aux = [dado.Pedido, dado.Cliente, dado.TelefoneCliente, dado.DataEmissao, dado.DataVencimento, dado.ValorString, dado.Status];
          corpo.push(aux);
        });

        autoTable(doc, {
          head: [["Pedido", "Cliente", "Telefone", "Emissão", "Vencimento", "Valor", "Status"]],
          theme: 'grid',
          body: corpo,
          margin: { top: 10, right: 5, bottom: 10, left: 5 },
          showHead: 'firstPage',
          showFoot: 'lastPage',
          foot: [["", "", "", "", "", "", ""]]
        });

        let tituloDocumento = '';
        switch (this.sTipoBusca) {
          case 'Boletos vencidos':
            tituloDocumento = `Relatório de boletos vencidos emitido em: ${this.usuarioService.tratarData(new Date().getTime())}.pdf`
            break;

          case 'Data de emissão':
            tituloDocumento = `Relatório com base na data de emissão - período: ${this.usuarioService.tratarData(date.getTime())} - ${this.usuarioService.tratarData(dateFinal.getTime())}.pdf`
            break;

          case 'Data de vencimento':
            tituloDocumento = `Relatório com base na data de vencimento - período: ${this.usuarioService.tratarData(date.getTime())} - ${this.usuarioService.tratarData(dateFinal.getTime())}.pdf`
            break;
        }
        doc.save(tituloDocumento);

        this.usuarioService.setLog(`Exportou relatório de boletos em PDF. ${tituloDocumento}`, null, this.uid);
        break;
    }
  }
}
